import React from 'react';
import styled from 'styled-components';
import { Group, spacing, MaestroComponent, IconProps } from '@landr/maestro';
import Slice from 'components/Slice/Slice';
import UspCard from './components/UspCard';

const GroupItem = styled(Group.Item)`
    margin-top: ${spacing('mg')};
    width: calc(33.33% - ${spacing('mg')});

    ${({ theme }): string => theme.breakpoint('xl')`
        width: calc(33.33% - ${spacing('xxl')});
    `};

    ${({ theme }): string => theme.breakpoint('lg')`
        width: calc(50% - ${spacing('xxl')});
    `};

    ${({ theme }): string => theme.breakpoint('md')`
    margin-top: ${spacing('xxl')};
        width: 100%;
    `};
`;

type Usp = {
    title: string;
    description: string;
    icon: MaestroComponent<IconProps, Record<string, any>>;
};

const UspCards = ({ usps }: { usps: Usp[] }) => (
    <Slice>
        <Group flexWrap="wrap" gutter={0} justifyContent="space-between">
            {usps.map((usp) => (
                <GroupItem key={usp.title}>
                    <UspCard
                        title={usp.title}
                        description={usp.description}
                        icon={usp.icon}
                    />
                </GroupItem>
            ))}
        </Group>
    </Slice>
);

export default UspCards;
